import { viewPromotion } from 'store/campaign/campaignActions';
import { createViewPromotionEvent } from '../eventCreators';
import { createViewPromotionEventPayload } from '../dataHelpers/createViewPromotionEventPayload';

const emitViewPromotion = ({ payload }) => {
  const viewPromotionEvent = createViewPromotionEvent(
    createViewPromotionEventPayload({
      promotion: payload.promotion,
    }),
  );

  return viewPromotionEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [viewPromotion]: emitViewPromotion };
